import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { S3Connection } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';
import { RegionsResource } from '../../resources/regions.resource';

@Component({
  selector: 'connection-form-s3',
  template: `
    <xp-form-validation type="AmazonS3Connection" [name]="formName">
      <form id="connectionFormS3" name="connectionFormS3" #form="ngForm" class="form">
        <div class="row">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="region">{{ 'connections.form.athena.labels.region' | translate }}</label>
              <xp-select
                class="form-control xp-select"
                id="region"
                name="region"
                [value]="connection.region"
                [options]="s3Regions"
                [isGrouped]="true"
                [isSearchEnabled]="true"
                panelClass="connection-select-box"
                (valueChange)="onRegionChange($event)"
                emptyPlaceholder="No region found"
              >
              </xp-select>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
          </div>
          <div class="col-md-6">
            <connection-component-username-password
              [connection]="connection"
              usernameTranslationKey="connections.form.s3.labels.username"
              passwordTranslationKey="connections.form.s3.labels.password"
            ></connection-component-username-password>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormS3Component extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<S3Connection> = {};
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormS3';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];
  s3Regions = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
    @Inject('$rootScope') private $rootScope: any,
    private regionsResource: RegionsResource,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.regionsResource.query('s3').subscribe((s3Regions) => {
      this.s3Regions = s3Regions.map(({ id, short_name, group_name }) => ({
        text: short_name,
        value: id,
        group_name,
      }));
    });
  }

  onRegionChange(region: string) {
    this.connection.region = region;
  }
}
